module.exports = __webpack_public_path__ + "static/media/banner-ban-cu.1dea4b45.jpg";